<template>
  <div
    class="question-image__wrapper"
    id="canvas-question-image-wrapper"
  >
    <div class="question-image-modal">
      <div class="question-image-overlay"></div>
      <div class="question-image__image">
        <div class="question-image__image_content">
          <img
            :src="questionImage"
            alt
            class="question-image __image relative z-10"
            ref="slide-imgg"
            @load="imageLoaded"
            id="canvas-question-image"
            @click.stop="expandCollapseTrigger()"
          >
          <div id="close-full-question-image">
            <aha-icon
              name="close"
              class="close-icon cursor-pointer"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              @click.stop="expandCollapseTrigger()"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="question-image __image-wrapper relative image-pointer-zoom-in __image-wrapper-poll-mode"
      :class="{
        'pointer-events-none': isLockPointerEvent,
      }"
      v-if="questionImage"
      id="img-wrapper"
    >
      <div class="question-image __icons top-2 left-2" v-if="!isPresenting">
        <div
          class="question-image __edit-wrapper"
          @click="openEditQuestionImageModal"
          v-tooltip="$i18nPresenter.t('Edit image')"
        >
          <font-awesome-icon
            icon="pencil-alt"
            class="question-image __icon"
          />
        </div>
        <div
          class="question-image __delete-wrapper"
          @click="openDeleteQuestionImageModal"
          v-tooltip="$i18nPresenter.t('Delete')"
        >
          <font-awesome-icon
            icon="trash-alt"
            class="question-image __icon"
          />
        </div>
      </div>
      <div
        class="relative inline overflow-hidden question-image__contain"
      >
        <img
          :src="questionImage"
          alt
          class="question-image __image relative z-10"
          ref="slide-imgg"
          @load="imageLoaded"
          id="canvas-question-image"
          @click.stop="expandCollapseTrigger()"
        >
        <div
          class="absolute top-2 right-2 z-20"
          id="expand-icon-wrapper"
        >
          <div
            class="expand-icon"
            @click.stop="expandCollapseTrigger()"
          >
            <i
              class="fas fa-expand-alt __icon"
              style="font-size: 24px; padding-top: 6px"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import EventBus from '@/eventBus'

export default {
  computed: {
    ...mapGetters(['isPresenting']),
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    isLockPointerEvent() {
      return false
    },
    questionImage() {
      return (this.slideActive.image && this.slideActive.image.xLarge)
    },
  },
  methods: {
    expandCollapseTrigger(val) {
      this.$emit('expandCollapseTrigger', val)
    },
    imageLoaded() {
      this.$emit('imageLoaded')
    },
    openEditQuestionImageModal() {
      EventBus.$emit('open-edit-question-image-modal')
    },
    openDeleteQuestionImageModal() {
      EventBus.$emit('open-delete-question-image-modal')
    },
  },
}
</script>

<style lang="scss" scoped>
.question-image__wrapper {
  width: 100%;
  height: 100%;
  &::v-deep {
    .spinner {
      width: 120px;
      margin: 0 auto;
    }
    .spinner > div {
      width: 20px;
      height: 20px;
      margin: 0 8px;
    }
  }
  .question-image-modal {
    @apply fixed inset-0;
    z-index: 200;
    visibility: hidden;

    .question-image-overlay {
      @apply absolute inset-0 bg-base-100 opacity-50;
    }
    .question-image__image {
      top: 60px;
      width: 100%;
      display: flex;
      position: relative;
      height: calc(100% - 160px);
      animation-name: fadeOut;
      animation-duration: 0.5s;
      animation-fill-mode: both;

      #close-full-question-image {
        top: 8px;
        right: 8px;
        z-index: 10;
        display: none;
        color: #282E3E;
        padding: 3px 4px;
        border-radius: 4px;
        position: absolute;
        background-color: #fff;
        &:hover {
          svg {
            @apply text-primary-100;
          }
        }
      }
      .question-image__image_content {
        display: flex;
        position: relative;
        height: 100%;
        margin: auto;
        &:hover {
          #close-full-question-image {
            display: block;
          }
        }
      }
    }
  }
  &::v-deep .context-menu-wrapper {
    min-width: 3rem;
  }
  .context-menu-item__wrapper {
    padding-left: 0;
    margin-bottom: 0;
  }

  .question-image {
    &.__icons {
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 4px;
      border: 1px solid #ccc;
      filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.12));
      width: max-content;
      opacity: 0;
      z-index: 500;
      position: absolute;
      .__edit-wrapper {
        @apply p-2 pr-2 cursor-pointer;
        &:hover .__icon {
          @apply text-primary-100;
        }
      }
      .__delete-wrapper {
        @apply p-2 pl-2 cursor-pointer;
        &:hover .__icon {
          @apply text-red-100;
        }
      }
    }
    &.__icon {
      font-size: 1.25em;
      @apply text-base-100;
    }
    &.__image {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      display: table;
      margin: 0 auto;
      border-radius: 8px;
      &:hover {
        cursor: zoom-in;
      }
    }
    &.__image-wrapper {
      @apply h-full w-full my-0 mx-auto;
      &:hover {
        background-color: rgba(209, 209, 209, 0.2);
        .__icons {
          opacity: 1;
        }
        .expand-icon {
          opacity: 1;
        }
        .collapse-icon {
          opacity: 1;
        }
      }
    }
    &.__image-wrapper-poll-mode {
      flex-direction: column !important;
      justify-content: center !important;
    }
    .question-image__contain {
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      border-radius: 8px;
      width: 100%;
      height: 100%;
      display: flex;
    }
  }
  &.full-canvas-image-width {
    .question-image-modal {
      visibility: visible;
      .question-image__image {
        width: 100%;
        animation-name: fadeIn;
        animation-duration: 0.5s;
        animation-fill-mode: both;
      }
    }
    .question-image.__image-wrapper {
      opacity: 0;
    }
    .question-image {
      &.__image {
        &:hover {
          cursor: zoom-out;
        }
      }
    }
  }
  &:not(.full-canvas-image-width) {
    .question-image.__image-wrapper {
      animation-name: fadeIn;
      animation-duration: 0.5s;
      animation-fill-mode: both;
    }
    .question-image-modal {
      visibility: hidden;
    }
  }
  .expand-icon {
    @apply w-10 h-10 absolute rounded top-1 right-1 text-center cursor-pointer;
    background-color: #ffffff;
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.12));
    opacity: 0;
    i {
      @apply text-base-100;
    }
    &:hover {
      i {
        @apply text-primary-100;
      }
    }
  }
  .collapse-icon {
    @apply w-10 h-10 absolute rounded right-8 text-center cursor-pointer;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1px solid #ccc;
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.12));
    opacity: 0;
    i {
      @apply text-base-100;
      font-size: 24px;
      padding-top: 8px;
    }
    &:hover {
      i {
        @apply text-primary-100;
      }
    }
  }
}
</style>
